module.exports = __webpack_public_path__ + "static/media/vehicleListIconActive.d373a625.svg";